var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.related_shop_ids.length > 0)?_c('div',{staticClass:"related_shops pt-6 md:pt-12"},[_c('ul',_vm._l((_vm.item.related_shop_ids),function(shopId){return _c('RelatedShop',{key:shopId,attrs:{"shop-id":shopId}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }